import React, { createContext, useContext, useReducer } from 'react';
import { message } from 'antd';

interface ICartInfo {
  title: String,
  price: Number,
  dPrice: Number,
  des: String
}

interface IState {
  cart: ICartInfo[]
}

const initialState:IState = {
  cart: []
};

interface IAction {
  type:
    "ADD_TO_CART"
  | "REMOVE_FROM_CART"
  | "CLEAR_CART",
  payload: ICartInfo
}

const StoreContext = createContext<{ state: IState; dispatch: React.Dispatch<IAction>}>({state: initialState, dispatch: () => undefined});

const reducer = (state:IState, action:IAction) => {
  switch(action.type) {
    case "ADD_TO_CART":
      const isAdded = state.cart.find(data => data.title === action.payload.title)
      if (!isAdded) {
        message.success('Item added successfully!');
        return {
          ...state,
          cart: [
            ...state.cart,
            action.payload
          ]
        }
      }else{
        message.warning('The item has already been added to the cart!');
        return state
      }
    case "REMOVE_FROM_CART":
      return {
        ...state,
        cart: state.cart.filter((data) => data.title !== action.payload.title)
      }
    case "CLEAR_CART":
      return {
        ...state,
        cart: []
      }
    default:
      return state
  }
}

export const StoreProvider:React.FC = ({children}) => {
  
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StoreContext.Provider value={{state, dispatch}}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStore = () => useContext(StoreContext);
